var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33530_2853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7917 7.75363C11.7237 7.56136 11.6189 7.38653 11.4856 7.23765C11.2022 6.92098 10.7903 6.72168 10.3318 6.72168H9.13368C8.37058 6.72168 7.75195 7.34029 7.75195 8.10341C7.75195 8.75274 8.20408 9.31446 8.83842 9.45321L10.6626 9.85226C11.3732 10.0077 11.8798 10.6374 11.8798 11.3649C11.8798 12.2198 11.1867 12.9134 10.3318 12.9134H9.29989C8.62591 12.9134 8.05254 12.4826 7.84004 11.8814",
    stroke: "#06C86B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81641 6.72176V5.17383",
    stroke: "#06C86B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81641 14.461V12.9131",
    stroke: "#06C86B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36328 18.6226V15.3057H6.68025",
    stroke: "#06C86B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4751 8.41309C19.3004 12.802 16.6146 17.1532 12.2295 18.3281C8.87333 19.2274 5.44891 18.0177 3.36328 15.5114",
    stroke: "#06C86B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52358 11.587C0.698264 7.19809 3.3841 2.84694 7.76917 1.67198C11.1251 0.772753 14.5493 1.98221 16.635 4.48815",
    stroke: "#06C86B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6354 1.37793V4.6949H13.3184",
    stroke: "#06C86B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33530_2853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.fb85a33421afd37e675a2abf8783b270.svg";
export { ForwardRef as ReactComponent };